"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/builtin/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FormControlLabel.default;
  }
});

var _FormControlLabel = _interopRequireDefault(require("./FormControlLabel"));


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/core/FormControlLabel/index.js
 ** module id = 856
 ** module chunks = 0
 **/